<script lang="ts">
    // Linha de "coisa escolhida" dentro de um bloco: iniciais (ou ícone) + nome + uma linha de apoio,
    // com um botão opcional de remover à direita. Serve para cliente, serviço, agenda, sala, insumo.
    import Fa from 'svelte-fa'
    import { faTimes } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    let className: string = ''
    export { className as class }
    export let title: string = ''
    export let subtitle: string = ''
    // iniciais do avatar; se vazio e houver ícone, mostra o ícone; se nada, não mostra avatar
    export let initials: string = ''
    export let icon: any = null
    export let removable: boolean = false
    export let removeTitle: string = 'Remover'
    export let clickable: boolean = false
    // fundo do cartão da linha (quando várias linhas convivem, ex.: lista de serviços)
    export let boxed: boolean = true

    function onClick() {
        if (!clickable) return
        dispatch('click')
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-static-element-interactions -->
<div class="zentity {className}" class:boxed class:clickable on:click={onClick}>
    {#if initials || icon}
        <div class="zentity_avatar">
            {#if initials}
                {initials}
            {:else}
                <Fa {icon} />
            {/if}
        </div>
    {/if}
    <div class="zentity_text">
        <div class="zentity_title">{title}</div>
        {#if subtitle}
            <div class="zentity_sub">{subtitle}</div>
        {/if}
        <slot />
    </div>
    <slot name="trailing" />
    {#if removable}
        <button type="button" class="zentity_remove" title={removeTitle} on:click|stopPropagation={() => dispatch('remove')}>
            <Fa icon={faTimes} />
        </button>
    {/if}
</div>

<style>
    /* valores base = tema escuro */
    .zentity {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px;
        border-radius: 10px;
    }
    .zentity.boxed {
        background: var(--z-field-bg);
        border: 1px solid var(--z-field-border);
    }
    .zentity.clickable {
        cursor: pointer;
    }
    .zentity_avatar {
        flex: 0 0 38px;
        height: 38px;
        border-radius: 50%;
        background: #4a5a78;
        color: #dce6f7;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 700;
        text-transform: uppercase;
    }
    .zentity_text {
        flex: 1 1 auto;
        min-width: 0;
    }
    .zentity_title {
        font-size: 15px;
        font-weight: 600;
        line-height: 1.25;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .zentity_sub {
        font-size: 12.5px;
        opacity: 0.55;
        line-height: 1.3;
        margin-top: 1px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    /* mesmo botãozinho das ações dentro de um campo (ver css_z_field.css) */
    .zentity_remove {
        flex: 0 0 auto;
        width: var(--z-field-act-size);
        height: var(--z-field-act-size);
        border: 0px;
        border-radius: var(--z-field-act-radius);
        background: var(--z-field-act-bg);
        color: inherit;
        opacity: 0.85;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
    }

    /* fundo, borda e botão vêm das variáveis dos campos, que já mudam sozinhas no tema claro */
    :global(.theme_light) .zentity_avatar {
        background: #e6ebf5;
        color: #4a5a78;
    }
</style>
